import { useState } from 'react';
import { QuyenChungTu, TaiKhoan } from '@/types/schemas';

export interface InfoTabFormFieldStates {
  taiKhoan: TaiKhoan | null;
  setTaiKhoan: (taiKhoan: TaiKhoan | null) => void;
  quyenChungTu: QuyenChungTu | null;
  setQuyenChungTu: (quyenChungTu: QuyenChungTu | null) => void;
  soChungTu: string;
  setSoChungTu: (soChungTu: string) => void;
}

/**
 * Hook for managing search field states in the hoa-don-ban-hang form-dialog
 * Following the pattern from useSearchDialogState
 *
 * @returns Object with states and setters for search fields
 */
export const useFormFieldStates = (initialData?: BanHangRecord) => {
  const [taiKhoan, setTaiKhoan] = useState<TaiKhoan | null>(initialData?.tk_data || null);

  const [quyenChungTu, setQuyenChungTu] = useState<QuyenChungTu | null>(initialData?.ma_nk_data || null);
  const [soChungTu, setSoChungTu] = useState<string>(initialData?.so_ct || '');
  // Reset all states
  const resetAllStates = () => {
    setTaiKhoan(null);
    setQuyenChungTu(null);
    setSoChungTu('');
  };

  // Update multiple states at once
  const updateStates = (updates: {
    taiKhoan?: TaiKhoan | null;
    quyenChungTu?: QuyenChungTu | null;
    soChungTu?: string;
  }) => {
    if (updates.taiKhoan !== undefined) setTaiKhoan(updates.taiKhoan);
    if (updates.quyenChungTu !== undefined) setQuyenChungTu(updates.quyenChungTu);
    if (updates.soChungTu !== undefined) setSoChungTu(updates.soChungTu);
  };

  return {
    // States
    taiKhoan,
    quyenChungTu,
    soChungTu,

    // Setters
    setTaiKhoan,
    setQuyenChungTu,
    setSoChungTu,

    // Utility functions
    resetAllStates,
    updateStates
  };
};
